__turbopack_context__.v({
  "donate_row": "CWBWDq_donate_row",
  "donate_row__background": "CWBWDq_donate_row__background",
  "donate_row__button": "CWBWDq_donate_row__button",
  "donate_row__button_text": "CWBWDq_donate_row__button_text",
  "donate_row__content": "CWBWDq_donate_row__content",
  "donate_row__foreground_image": "CWBWDq_donate_row__foreground_image",
  "donate_row__inner": "CWBWDq_donate_row__inner",
  "donate_row__title": "CWBWDq_donate_row__title",
});
